import React, { useState } from 'react';
import CustomTextField from '../../form-controls/custom-text-field/Custom-Text-Field';
import './BackgroundColor.scss';

const BackgroundColor = (props) => {
  const { formData, setFormData, title, fieldKey, defaultColor } = props;
  const [isHsxColor, setIsHsxColor] = useState(false);

  return (
    <div className='background-color row'>
      <p className='background-color-text col-md-7'>{title}</p>
      <div className='col-md-5'>
        <div
          className='background-color-display ms-5'
          style={{
            backgroundColor: formData[fieldKey].value || defaultColor || '#82828214',
          }}
          onClick={() => setIsHsxColor(!isHsxColor)}
        ></div>
        {isHsxColor && (
          <CustomTextField
            item={formData[fieldKey]}
            handleInputChange={(e) => {
              setFormData({ [fieldKey]: e });
            }}
          />
        )}
      </div>
    </div>
  );
};

export default BackgroundColor;
